// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { envUrl } from '../services/environment/EnvironmentService';
import UnauthorizedIcon from '../assets/unauthorized.svg';
import messages from '../../data/common';

import './UnauthorizedComponent.scss';

type Props = {
  history: Object,
  contactDetails: Object,
};

type Context = {
  intl: Object,
};

const UnauthorizedComponent = ({ history, contactDetails }: Props, { intl }: Context) => (
  <div className="UnauthorizedComponent">
    <div className="UnauthorizedComponent__container">
      <div className="UnauthorizedComponent__icon">
        <img alt="Unauthorized Approvals Icon" src={UnauthorizedIcon} />
      </div>
      <div className="UnauthorizedComponent__title">{intl.formatMessage(messages.unauthorizedTitle)}</div>
      <div className="UnauthorizedComponent__text">
        {intl.formatMessage(messages.unauthorizedText, {
          accountType: contactDetails.type === 'accountManager' ? 'account manager' : 'primary admin',
        })}
        <a href={`mailto:${contactDetails.email}`} className="UnauthorizedComponent__accountManagerEmail">
          {contactDetails.email}
        </a>
      </div>
      <div className="UnauthorizedComponent__ctas">
        <Button type={buttonTypes.PRIMARY} size={buttonSizes.MEDIUM} onClick={() => history.push(envUrl('/products'))}>
          {intl.formatMessage(messages.unauthorizedButtonText)}
        </Button>
      </div>
    </div>
  </div>
);

UnauthorizedComponent.displayName = 'UnauthorizedComponent';

UnauthorizedComponent.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

export default withRouter(UnauthorizedComponent);
